<template>

  <div class="product-list">

    <div v-for="(product, index) in products" :key="product.id" :data-index="index">

      <div class="product-item" ref="productItem">
        <!-- 左侧产品图 -->
        <div class="product-pic" ref="productPic">
          <img
            :src="product.pic"
            :srcset="product.pic2x ? product.pic2x + ' 2x' : null"
            :alt="(product.name || '产品') + ' 应用场景'"
            class="img zoomable"
            @click="$emit('open3d', product)"
          />
          <!-- 3D 构建图入口：压在左侧场景图上，整段滚动过程中一直可见 -->
          <button class="view3d" type="button" @click="$emit('open3d', product)">
            <span>3D</span>{{ product.model3dTitle || '结构构建图' }}
          </button>
        </div>
        <!-- 右侧产品信息和描述 -->
        <div class="product-info-desc">
          <div class="p-info-con">
            <div class="product-info">
              <img
                :src="product.info"
                :srcset="product.info2x ? product.info2x + ' 2x' : null"
                :alt="(product.name || '产品') + ' 产品信息'"
                class="zoomable"
                loading="lazy"
                decoding="async"
                @click="$emit('open3d', product)"
              />
              <a v-if="product.url" :href="product.url" class="link" target="_blank" rel="noopener">
                <img src="../../img/product/btn-down.png" alt="下载产品样册" />
              </a>
            </div>
            <div class="product-desc">
              <img
                :src="product.desc"
                :srcset="product.desc2x ? product.desc2x + ' 2x' : null"
                :alt="(product.name || '产品') + ' 产品卖点'"
                class="zoomable"
                loading="lazy"
                decoding="async"
                @click="$emit('open3d', product)"
              />
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
  props: {
    // 不传则沿用给水系统页的 6 个系列，其它产品页按同样结构传入即可
    products: {
      type: Array,
      default: () => ([
        {
          id: 1,
          name: '贝瑞斯系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p1-pic.jpg'),
          info: require('@/img/product/p1-info.jpg'),
          desc: require('@/img/product/p1-desc.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E8%B4%9D%E7%91%9E%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf',
          fixed: false,
        }
        ,{
          id: 2,
          name: '普乐仕系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p2-pic.jpg'),
          info: require('@/img/product/p2-info.jpg'),
          desc: require('@/img/product/p2-desc.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%99%AE%E4%B9%90%E4%BB%95%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf',
          fixed: false,
        },{
          id: 3,
          name: '梵尔西/伊耐斯系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p3-pic.jpg'),
          info: require('@/img/product/p3-info.jpg'),
          desc: require('@/img/product/p3-desc.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%A2%B5%E5%B0%94%E8%A5%BF_%E4%BC%8A%E8%80%90%E6%96%AF%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf',
          fixed: false,
        },{
          id: 4,
          name: '法斯特系列',
          model: 'press-fitting-copper',
          model3dTitle: '铜管压接接头',
          pic: require('@/img/product/p4-pic.jpg'),
          info: require('@/img/product/p4-info.jpg'),
          desc: require('@/img/product/p4-desc.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%C2%B7%E6%B3%95%E6%96%AF%E7%89%B9%E7%B3%BB%E5%88%97%E4%BA%A7%E5%93%81%E6%A0%B7%E5%86%8C.pdf',
          fixed: false,
        },{
          id: 5,
          name: '住宅给水阀门系列',
          model: 'ball-valve',
          model3dTitle: '全通径黄铜球阀',
          pic: require('@/img/product/p5-pic.jpg'),
          info: require('@/img/product/p5-info.jpg'),
          desc: require('@/img/product/p5-desc.jpg'),
          url: 'https://book.yunzhan365.com/gzdv/wtwn/mobile/index.html',
          fixed: false,
        },{
          id: 6,
          name: '工程不锈钢系列',
          model: 'press-fitting',
          model3dTitle: '双卡压不锈钢管件',
          pic: require('@/img/product/p6-pic.jpg'),
          info: require('@/img/product/p6-info.jpg'),
          desc: require('@/img/product/p6-desc.jpg'),
          url: 'https://qiniu.cdn.wepie.cc/web/ts-conex/download/%E7%8F%AD%E5%B0%BC%E6%88%88%E5%B7%A5%E7%A8%8B%E7%BB%99%E6%B0%B4%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C.pdf',
          fixed: false,
        }
        // 添加更多产品数据...
      ])
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);    

    let container = document.querySelector(".product-list"),
        slides = gsap.utils.toArray(".product-item");
    let getRatio = (el) => window.innerHeight / (window.innerHeight + el.offsetHeight);
// ScrollTrigger.create({
//     trigger: '.product-list', //skyblue元素
//     start: 'top top', //.skyblue元素的顶部开始  
//     end: '+=5000',  // 到1600px结束
//     // scrub: true,  // 关键点  和滚动条绑定
//     pin: true,  //固定起始位置
//     markers: true //开始标记  结束标记
// });
console.log(container);
slides.forEach((slide, i) => {
  console.log(i)
  let con = slide.querySelector(".p-info-con");
  let right = slide.querySelector(".product-info-desc");
  gsap.set(right, {
    'width': 0,
    // scale: 0.5,
    // y: 1000,
    // x: totalWidth,
  });

  ScrollTrigger.create({
      trigger: slide, //skyblue元素
      start: 'top top', //.skyblue元素的顶部开始  
      // end: "bottom top",
      // end: `+=${con}`, // 增加一些额外空间以确保内容滚动
      end: '+=2450',  // 到1600px结束
      scrub: true,  // 关键点  和滚动条绑定
      pin: true,  //固定起始位置
      // pinSpacing: false, // 不留空白
      // markers: true, //开始标记  结束标记,
  });

  let pic = slide.querySelector(".product-pic"),
      tl = gsap.timeline({
          scrollTrigger: {
            // trigger: slide,
            // start: () => i ? "top bottom" : "top top",
            // end: "bottom top",
            // scrub: true,
            // invalidateOnRefresh: true
            trigger: pic,
            start: "top-=200 top",
            // start: "top top",
            // end: "bottom-=200 top",
            end: "bottom top",
            // start: 'top-=500 top',
            // end: `+=${con}`, // 增加一些额外空间以确保内容滚动
            // end: 'botom+=2500',
            scrub: true,
            // pin: true,  //固定起始位置
            // animation: gsap.timeline()
            // .fromTo(
            //   bg,
            //   { 'margin-left': '1500px', opacity: 0 },
            //   { 'margin-left': '0px', opacity: 1 }
            // )
            // toggleActions: "restart pause reverse pause"
          }
        });

        tl.from(pic, { 'margin-left': '2000', 'width': '50%', opacity: 0, scale: 1.8 } )
          .to(pic, { 'margin-left': '0', 'width': '100%', opacity: 1, scale: 1 })
          .to(pic,  { 'margin-left': '0', 'width': '50%', opacity: 1, scale: 1,
            onComplete:function () { // 动画播放完成时调用
              gsap.set(right, {
                'width': '50%'
              });
              let right1 = gsap.timeline({
              // let right1 = gsap.to({
                scrollTrigger: {
                  trigger: con,
                  start: "top top",
                  end: 'bottom top',
                  scrub: true
                }
              });
              right1.fromTo(con, 
                { y: 100, opacity: 1,  scale: 1 },
                { y: -2700, opacity: 1, scale: 1 }
              );
              }
          });
          console.log(getRatio);
          console.log(con);
          console.log(right);
      }
    );
  }
};
</script>

<style scoped lang="less">
.product-list {
  height: 100%;
  // height: 100vh;
  // height: 800px;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
  /* padding: 20px; */
  // background: red;

  overflow: hidden;
}

.product-item {
  height: 100%;
  height: 100vh;
  /* width: calc(50% - 20px); */
  /* margin-bottom: 20px; */
  /* height: 800px; */
  width: 100%;
  background-color: black;
  background-color: #1B2329;
  background-color: #FFF;
  background-color: #000;
  // background-color: rgba(0, 0, 0, 0.7);
  
  /* border-radius: 10px; */
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  // overflow: hidden;
  position: relative;
  
// background-color: #FFF;

  display: flex;
  .product-pic {
//     position: absolute;
//     top: 0;
// left: 0;
    margin-left: 1200px;
    // flex: 1;
    width: 50%;
    // width: 100%;
    height: 100%;
    overflow: hidden;
    
// opacity:0 ;

//  width: 50%;
//   height: 100vh;
//   overflow: hidden;
//   position: sticky;
//   left: 0;
    img {
      width: 100%;
      // height: auto;
      height: 100%;
      // height: 100vh;
      object-fit: cover;
      // object-fit: fill;
    }
  }
  .product-info-desc {
    background-color: #FFF;
    // background-color: red;
    // height: 100vh;
    // overflow: hidden;
    // flex: 1;
    width: 50%;
    height: auto;
    height: 100%;
    // position: relative;
    overflow: hidden;
    // overflow-y: scroll;
    .p-info-con {
      width: 100%;
      height: auto;
      // display: none;
      // height: 2000px;
      // position: absolute;
      background-color: #FFF;
    }
    img {
      width: 100%;
      height: auto;
      // height: 100vh;
      // object-fit: cover;
      // object-fit: fill;
    }
  }
  .product-info {
    position: relative;
    padding: 100px;
    img {
      // width: 90%;
      // height: 90%;
    }
    .link {
      display: block;
      width: 133px;
      height: 23px;
      position: absolute;
      margin: 0 auto;
      left: 0;
      right: 0;
      bottom: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .product-desc {
    p {
      font-size: 0rem;
      margin: 0;
    }
  }
  /* 3D 构建图入口，压在左侧场景图左下角 */
  .view3d {
    position: absolute;
    left: 48px;
    bottom: 48px;
    z-index: 5;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 11px 20px;
    font-size: 14px;
    color: #fff;
    background: rgba(10, 18, 22, 0.55);
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 3px;
    cursor: pointer;
    backdrop-filter: blur(4px);
    transition: 0.25s;
    span {
      font-size: 11px;
      letter-spacing: 1px;
      border: 1px solid currentColor;
      border-radius: 2px;
      padding: 1px 5px;
    }
    &:hover {
      background: #0c8066;
      border-color: #0c8066;
    }
  }
}
</style>

<style>
/* .product-list {
  background: red;
}

.product-item {
  display: flex;
  background-color: #fff;
  overflow: hidden;
  position: relative;
}
.product-pic {
  width: 50%;
  height: 100%;
  overflow: hidden;
}

.product-pic img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.product-info-desc {
  width: 50%;
}
.product-info-desc  img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.product-info h2 {
  font-size: 0rem;
  margin-top: 0;
}

.product-desc p {
  font-size: 0rem;
  margin: 0;
} */
</style>
